import React from "react";

function Icon(data) {
  return (
     <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
      width={data.w} height={data.h}
    >
      <path
        d="M25.81 27.28a4.735 4.735 0 0 1-1.214.157c-2.612 0-4.76-2.148-4.76-4.76 0-2.611 2.148-4.76 4.76-4.76A4.772 4.772 0 0 1 29.2 21.47c.662 2.523-.868 5.145-3.39 5.81Zm-2.13-8.09a3.62 3.62 0 0 0-2.691 3.491c0 1.98 1.63 3.61 3.61 3.61 1.981 0 3.61-1.63 3.61-3.61 0-.311-.04-.62-.119-.921a3.627 3.627 0 0 0-4.41-2.57ZM23.14 16.35a.572.572 0 0 1-.7-.4l-1-3.88a.577.577 0 0 1 .555-.719c.26 0 .489.177.555.429l1 3.87a.571.571 0 0 1-.41.7ZM34.63 20.27l-3.87 1a.577.577 0 0 1-.719-.555c0-.26.177-.489.429-.555l3.87-1a.577.577 0 0 1 .719.555c0 .26-.177.489-.429.555ZM27.5 33.22a.557.557 0 0 1-.7-.4l-1-3.88a.577.577 0 0 1 .555-.719c.26 0 .489.177.555.429l1 3.87a.571.571 0 0 1-.41.7ZM18.86 24.42l-3.87 1a.583.583 0 0 1-.723-.567c0-.256.175-.48.423-.543l3.88-1a.572.572 0 0 1 .7.4.583.583 0 0 1-.41.71Z"
        style={{
          fill: "#3d3833",
          fillRule: "nonzero",
        }}
        transform="translate(-27.137 -22.231) scale(2.07343)"
      />
      <path
        d="M28.06 17.07a.573.573 0 0 1-.64-.85l1.1-1.84a.578.578 0 0 1 1 .58l-1.09 1.85a.608.608 0 0 1-.37.26ZM19.14 19.31a.57.57 0 0 1-.44-.06l-1.84-1.09a.578.578 0 0 1 .58-1l1.85 1.09a.582.582 0 0 1-.15 1.06ZM19.88 31a.573.573 0 0 1-.64-.85l1.09-1.84a.582.582 0 0 1 .79-.2.572.572 0 0 1 .2.78l-1.09 1.85a.611.611 0 0 1-.35.26ZM32.72 27.21a.57.57 0 0 1-.44-.06l-1.85-1.09a.58.58 0 1 1 .59-1l1.84 1.09a.561.561 0 0 1 .2.79.56.56 0 0 1-.34.27Z"
        style={{
          fill: "#dfa370",
          fillRule: "nonzero",
        }}
        transform="translate(-27.137 -22.231) scale(2.07343)"
      />
    </svg>

  );
}

export default Icon;
